import TagsContainer from './TagsContainer'

export default TagsContainer
